/**
 * Program: EventBus
 * Author: SDL
 * Description: event emit use
 */
import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./src/utils/EventBus.js